
const TimeConversion = {
    secondsToMins: (seconds) => `${seconds/60} ${seconds/60 > 1? 'minutes':'minute'}`,
    secondsToHrs: (seconds) => `${seconds/(60*60)} ${seconds/(60*60) > 1? 'hours':'hour'}`
}

export default TimeConversion;